import './Blog.css';
import { useState } from 'react';

function Blog() {

  let [list, setList] = useState([
    ['망그러진 곰', '김예영', "2024.06.30", "망그러진 곰은 잠옷이 특히 귀엽다. 최근에 두산베어스와 콜라보했는데 매우 귀여웠따.", 0, 0],
    ['곽철이', '김예영', "2024.06.30", "곽철이는 이름이 특히 귀엽다. 공식굿즈도 샀다. 곽철이가 그려진 맥주잔", 0, 0],
    ['부실감자', '김예영', "2024.06.30", "부실감자는 대학생이다. 부실감자는 항상 힘없고 의욕없다.. 나같다", 0, 0]]);

  let [modal, setModal] = useState(false);
  let [modalIndex, setModalIndex] = useState('');

  let [제목입력, set제목입력] = useState('');
  let [user, setUser] = useState('');
  let [date, setDate] = useState('');
  let [content, setContent] = useState('');


  return (
    <div className="blog-container">
      <br></br>
      <h2 style={{color:'seagreen'}}>🔍Blog</h2>

      <div className="left-container">
        <div className="form">
          <div className="w-100">
            <h4>제목</h4>
            <input onChange={(e) =>{
              set제목입력(e.target.value);
            }}></input>
          </div>
          <div className="w-50">
            <h4>작성자</h4>
            <input onChange={(e) =>{
              setUser(e.target.value);
            }}></input>
          </div>
          <div className="w-50">
            <h4>날짜</h4>
            <input onChange={(e) =>{
              setDate(e.target.value);
            }}></input>
          </div>
          <div className="w-100">
            <h4>내용</h4>
            <input onChange={(e) =>{
              setContent(e.target.value);
            }}></input>
          </div>
          <div className="w-100">
            <button onClick={()=>{
              if(제목입력==''||user==''||date==''||content=='') {
                alert("내용을 입력하세요!");
              } else {
                const copylist = [...list];
                copylist.unshift([제목입력, user, date, content, 0, 0])
                setList(copylist);
              }
            }}>Upload</button>
          </div>
        </div>
      </div>
      <div className="right-container">
        {
          list.map(function (element, index){
            return (
              <List
                index={index} element={element} list={list} 
                setList={setList} setModal={setModal} setModalIndex={setModalIndex}>
              </List>
            )
          })
        }
      </div>
      {
        modal == true ? <Modal list={list} modalIndex={modalIndex} setModal={setModal}></Modal> : null
      }
    </div>
  );
}

function List({index, setModal, setModalIndex, list, setList}){
  return (
    <div className="list"
        onClick={()=>{
          setModal(true);
          setModalIndex(index);
        }}>
          <h4>
            {list[index][0]}
            <br></br>

            <span onClick={(e)=>{
              const copylist = [...list];
              copylist[index][4] += 1;
              setList(copylist);
              e.stopPropagation();
            }}>👍</span>
            {list[index][4]}

            <span onClick={(e)=>{
              const copylist = [...list];
              copylist[index][5] += 1;
              setList(copylist);
              e.stopPropagation();
            }}>👎</span>
            {list[index][5]}
          </h4>

          <p>{list[index][1]}</p>
          
          <p>{list[index][2]}</p>

          <button onClick={(e)=>{
            const copylist = [...list];
            copylist.splice(index, 1);
            setList(copylist);
            e.stopPropagation();
          }}>Delete</button>

        </div>
  )
}

function Modal({list, modalIndex, setModal}) {
  return (
    <div className="modal"
        onClick={()=>{setModal(false);}}>
      <h3>제목: {list[modalIndex][0]}</h3>
      <h4>작성자: {list[modalIndex][1]}</h4>
      <h4>날짜: {list[modalIndex][2]}</h4>
      <p>내용: {list[modalIndex][3]}</p>
    </div>
  )
}

export default Blog;
